
import React from 'react';
import { Users } from 'lucide-react';
import { CompetenceData } from '../../data/competencesData';

interface CompetenceSituationProps {
  situation: CompetenceData['situation'];
}

const CompetenceSituation = ({ situation }: CompetenceSituationProps) => {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-navy-50 rounded-2xl p-8 mb-12">
      <h2 className="text-2xl font-semibold text-navy-900 mb-6 flex items-center gap-2">
        <Users className="text-blue-600" size={24} />
        Mise en situation : Freelance en entreprise
      </h2>
      <div className="grid md:grid-cols-3 gap-6">
        <div>
          <h3 className="font-semibold text-navy-900 mb-2">Contexte</h3>
          <p className="text-navy-600 text-sm leading-relaxed">{situation.context}</p>
        </div>
        <div>
          <h3 className="font-semibold text-navy-900 mb-2">Défi</h3>
          <p className="text-navy-600 text-sm leading-relaxed">{situation.challenge}</p>
        </div>
        <div>
          <h3 className="font-semibold text-navy-900 mb-2">Solution</h3>
          <p className="text-navy-600 text-sm leading-relaxed">{situation.solution}</p>
        </div>
      </div>
    </div>
  );
};

export default CompetenceSituation;
